/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInChatPromptsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_inchat_prompts.pb'
import {GetInChatPromptsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_inchat_prompts.pb'


export const getInChatPrompts = (request: GetInChatPromptsRequest, options?: CashRequestOptions) => post<GetInChatPromptsRequest, GetInChatPromptsResponse>("/cash-app/goose-cash/v3/get-inchat-prompts", request, {...options, rejectOnError: true })